var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search row mb-5" },
    [
      _c("search-bar", {
        attrs: { placeholder: "Suchen" },
        model: {
          value: _vm.searchString,
          callback: function($$v) {
            _vm.searchString = $$v
          },
          expression: "searchString"
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.filteredList, function(element) {
        return _c(
          "div",
          { staticClass: "search__element col-12 mb-3 pb-3 border-bottom " },
          [_vm._t("element-slot", null, { element: element })],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }